export default __webpack_public_path__ + "static/media/logo.76763722.jpg";